import React from 'react';
import { ButtonGroup, Button } from '@nextui-org/react';

const IndustryMetricSelector = ({ selectedView, setSelectedView }) => {
  const buttonStyle = (view) => ({
    backgroundColor: selectedView === view ? '#245BA9' : 'transparent',
    borderColor: '#245BA9',
    color: selectedView === view ? 'white' : '#245BA9'
  });

  return (
    <div className="mb-4 flex justify-center">
      {/* Mobile view: stacked buttons */}
      <div className="flex flex-col w-full sm:hidden space-y-2 px-4">
        <Button
          style={buttonStyle('total')}
          onClick={() => setSelectedView('total')}
          className="w-full"
        >
          Total Nonfarm
        </Button>
        <Button
          style={buttonStyle('sectors')}
          onClick={() => setSelectedView('sectors')}
          className="w-full"
        >
          Private vs. Government
        </Button>
        <Button
          style={buttonStyle('industries')}
          onClick={() => setSelectedView('industries')}
          className="w-full"
        >
          Industries
        </Button>
      </div>

      {/* Desktop view: button group */}
      <ButtonGroup className="hidden sm:flex">
        <Button
          style={buttonStyle('total')}
          onClick={() => setSelectedView('total')}
        >
          Total Nonfarm
        </Button>
        <Button
          style={buttonStyle('sectors')}
          onClick={() => setSelectedView('sectors')}
        >
          Private vs. Government
        </Button>
        <Button
          style={buttonStyle('industries')}
          onClick={() => setSelectedView('industries')}
        >
          Industries
        </Button>
      </ButtonGroup>
    </div>
  );
};

export default IndustryMetricSelector;